import { ReactComponent as IconPlay } from "../svg/icon_play.svg";
import { ReactComponent as IconPause } from "../svg/icon_pause.svg";
import { ReactComponent as IconStop } from "../svg/icon_stop.svg";
import { ReactComponent as IconRecord } from "../svg/icon_record.svg";
import { ReactComponent as IconRecording } from "../svg/icon_recording.svg";
import { ReactComponent as IconHelp } from "../svg/icon_help.svg";
import { ReactComponent as IconSave } from "../svg/icon_save.svg";
import { ReactComponent as IconClose } from "../svg/icon_close.svg";
import { ReactComponent as IconUpload } from "../svg/icon_upload.svg";
import { ReactComponent as IconDownload } from "../svg/icon_download.svg";
import { ReactComponent as IconSettings } from "../svg/icon_settings.svg";
import { ReactComponent as IconRefresh } from "../svg/icon_refresh.svg";
import { ReactComponent as IconAutomation } from "../svg/icon_automation.svg";
import { ReactComponent as IconChordSound } from "../svg/icon_chord_sound.svg";
import { ReactComponent as IconChordEdit } from "../svg/icon_chord_edit.svg";
import { ReactComponent as IconChordDelete } from "../svg/icon_chord_delete.svg";
import { ReactComponent as IconChordChoose } from "../svg/icon_chord_choose.svg";
import { ReactComponent as IconScrolling } from "../svg/icon_scrolling.svg";
import { ReactComponent as IconTranscribe } from "../svg/icon_transcribe.svg";
import { ReactComponent as IconExtLink } from "../svg/icon_external_link.svg";
import { ReactComponent as IconCopyTabs } from "../svg/icon_copy_tabs.svg";
import { ReactNode } from "react";

// https://www.untitledui.com/free-icons
// These folks technically don't care about attribution.

// [mode][settings][upload]
// [mode][settings (per mode)][download][upload][play][pause]

export const ICON_CLOSE = <IconClose />; // "X"; // <CloseIcon />; //
export const ICON_HELP = <IconHelp />; // "?";
export const ICON_PLAY = <IconPlay />; // "\u{25B6}";
export const ICON_SAVE = <IconSave />; // "\u{1F4BE}";
export const ICON_PAUSE = <IconPause />; // "\u{23F8}";
export const ICON_RECORD = <IconRecord />; // "\u{23fA}";
export const ICON_RECORDING = <IconRecording />; // FIXME: NOT USED JUST NOTIONAL
export const ICON_STOP = <IconStop />; // "\u{23f9}";
export const ICON_UPLOAD = <IconUpload />; // "\u{2191}";
export const ICON_DOWNLOAD = <IconDownload />; // "⤓"; // "\u{2193}";
export const ICON_SETTINGS = <IconSettings />; // "\u{2699}";
export const ICON_BUG = "\u{1F41B}";
// export const ICON_NOTEOVERRIDE = <IconPin />; // "\u{1F4CC}";
export const ICON_AUTOMATION = <IconAutomation />; // "\u{1F916}";
export const ICON_SCROLLING = <IconScrolling />;
export const ICON_REFRESH = <IconRefresh />;
export const ICON_TRANSCRIBE = <IconTranscribe />;
export const ICON_EXT_LINK = <IconExtLink />;
export const ICON_COPY_TABS = <IconCopyTabs />;

export const ICON_CHORD_MODE = {
  SOUND: <IconChordSound />, // "\u{1F568}", // sound chords with a single click
  EDIT: <IconChordEdit />, // "\u{1F58B}", // explore and modify chord voicings
  DELETE: <IconChordDelete />, // "\u{1F5D1}", // delete chords with a single click
  CHOOSE: <IconChordChoose />, // send to instrumentation window with a single click
};

export const inlineIcon = (icon: ReactNode) => {
  return (
    <span
      style={{
        display: "inline-block",
        height: "1em",
      }}
    >
      {icon}
    </span>
  );
};
